import { createClient } from '@supabase/supabase-js';

// Environment variables validation
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing required environment variables');
}

// Create a single supabase instance
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// API endpoints configuration
export const API_ENDPOINTS = {
  PROFILES: 'profiles',
  PROJECTS: 'projects',
  REVIEWS: 'reviews',
} as const;

// Request timeout duration
export const REQUEST_TIMEOUT = 30000; // 30 seconds

// Rate limiting configuration
export const RATE_LIMIT = {
  MAX_REQUESTS: 100,
  TIME_WINDOW: 60000, // 1 minute
} as const;